import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './app-config.service';
import { Observable, BehaviorSubject, Subject } from "rxjs";
import 'devextreme/data/odata/store';
import jwt_decode from 'jwt-decode';
import { HeaderType, ResponseStatusType } from '../enumerators/enumerators.enum';
import { TranslateService } from '@ngx-translate/core';
import { SystemService } from './system.service';
import { tap } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Security } from '../utils/helpers/security';

declare var $: any;

export type InteralStateType = { [key: string]: any };

declare let require: any;

@Injectable()
export class AppService {
    public logOut: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public startIdleCount: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public sessionEnded: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    cryptoJS = require("crypto-js");

    public lightMode: boolean = false;
    public lightMode$ = new Subject<any>();
    public errorFiltroObligatorio: string;

    public headerAuthentication: string;
    public headerEncrypt: string;
    public headerValueJWE: string;
    public headerValueAES: string;
    public headerValueRSA: string;
    public headerNoSpinner: string;
    public headerContentType: string;
    public headerLanguage: string;

    public ignoreLoadingBar: boolean = false;

    constructor(private http: HttpClient, private configService: ConfigService, @Inject(DOCUMENT) private document: Document, private translate: TranslateService, private systemService: SystemService) {
        this.errorFiltroObligatorio = 'Selecciona al menos un filtro.';

        this.configService.config.servicesUrl = this.base64ToString(this.configService.config.servicesUrl);
        this.configService.config.secret = this.base64ToString(this.configService.config.secret);

        this.headerAuthentication = "Authorization";
        this.headerEncrypt = "X-Encode-Data";
        this.headerValueJWE = "SAP-ENC";
        this.headerValueAES = "AES-ENC";
        this.headerValueRSA = "RSA-ENC";
        this.headerNoSpinner = "ignoreLoadingBar";
        this.headerContentType = "Content-Type";
        this.headerLanguage = "Lenguaje";
    }

    //-- Lamadas secret servicios
    get(url: string, noHeaders: Array<HeaderType> = []): Observable<any> {
        if (noHeaders.length === 0) {
            noHeaders.push(HeaderType.Encryption);
        }

        let httpOptions = { headers: this.setHeader(noHeaders) };
        return this.http.get<any>(url, httpOptions).pipe(tap((response: any) => {
            if (response.status == ResponseStatusType.UNAUTHORIZED) {
                this.logOut.next(url);
            }
        }));
    }

    getPaginate(url: string, noHeaders: Array<HeaderType> = []): Observable<any> {
        if (noHeaders.length === 0) {
            noHeaders.push(HeaderType.Encryption);
        }

        return this.http.get<any>(url, { observe: 'response', headers: this.setHeader(noHeaders) }).pipe(tap((response: any) => {
            
            if (response.status == ResponseStatusType.UNAUTHORIZED) {
                this.logOut.next(url);
            }
        }));
    }

    public async getAsync(url: string, headers?: HeaderType[]) {
        let promise = new Promise((resolve, reject) => {
            this.get(url, headers).toPromise().then(res => { resolve(res); });
        });
        return promise;
    }

    post(url: string, datos: any, noHeaders: Array<HeaderType> = []): Observable<any> {
        if (noHeaders.length === 0) {
            noHeaders.push(HeaderType.Encryption);
        }
        let httpOptions = { headers: this.setHeader(noHeaders) };
        //let cuerpo = { "Token": this.encryptData(datos) };
        let cuerpo = this.encrypt(datos);
        return this.http.post(url, cuerpo, httpOptions).pipe(tap((response: any) => {
            if (response.status == ResponseStatusType.UNAUTHORIZED) {
                this.logOut.next(url);
            }
        }));
    }

    put(url: string, datos: any, noHeaders: Array<HeaderType> = []): Observable<any> {
        if (noHeaders.length === 0) {
            noHeaders.push(HeaderType.Encryption);
        }
        let httpOptions = { headers: this.setHeader(noHeaders) };
        //let cuerpo = { "Token": this.encryptData(datos) };
        let body = this.encrypt(datos);

        return this.http.put(url, body, httpOptions).pipe(
            tap((response: any) => {
                if (response.status == ResponseStatusType.UNAUTHORIZED) {
                    this.logOut.next(url);
                }
            })
        );
    }

    delete(url: string, noHeaders: Array<HeaderType> = []): Observable<any> {
        if (noHeaders.length == 0) {
            noHeaders.push(HeaderType.Encryption);
        }
        let httpOptions = { headers: this.setHeader(noHeaders) };

        return this.http.delete(url, httpOptions).pipe(tap((response: any) => {
            if (response.status == ResponseStatusType.UNAUTHORIZED) {
                this.logOut.next(url);
            }
        }));
    }

    changeTheme() {
        let themeLink = this.document.getElementById('app-themes') as HTMLLinkElement;
        var tema: string | null = localStorage.getItem('tema');

        if (themeLink) {

            if (tema && tema == "md-light-indigo.css") {
                tema = "md-dark-indigo.css";
                this.setDarkMode(true);
                localStorage.setItem("tema", "md-dark-indigo.css");
                themeLink.href = tema ? tema : "md-dark-indigo.css";
            } else {
                tema = "md-light-indigo.css";
                this.setDarkMode(false);
                localStorage.setItem("tema", "md-light-indigo.css");
                themeLink.href = tema ? tema : "md-light-indigo.css";
            }
        }
    }

    isDarkModeTheme() {
        var tema: string | null = localStorage.getItem('tema');
        return tema && tema == "md-dark-indigo.css" ? true : false;
    }

    postFile(url: string, filtros: any, noHeaders: Array<HeaderType> = []) {
        let httpOptions = { headers: this.setHeader(noHeaders) };
        let cuerpo = JSON.stringify(filtros);


        return this.http.post(url, cuerpo, httpOptions);

        /*map((response: any) =>
        {
            return {status: response.status, body: response._body};
        });*/
    }

    putFile(url: string, filtros: any, noHeaders: Array<HeaderType> = []) {
        let httpOptions = { headers: this.setHeader(noHeaders) };
        let cuerpo = JSON.stringify(filtros);


        return this.http.put(url, cuerpo, httpOptions);

        /*map((response: any) =>
        {
          let body: Blob = new Blob([response._body], {type: response.headers.get("content-type")});
            return {status: response.status, body: body};
        });*/
    }

    setHeader(encabezados: Array<HeaderType>): HttpHeaders {
        let headers = new HttpHeaders({});

        if (localStorage.getItem(this.systemService.localStoreVariable.JWT)) {
            headers = headers.set(this.headerAuthentication, encodeURIComponent(localStorage.getItem(this.systemService.localStoreVariable.JWT) as string));
        }

        headers = headers.set('Content-Type', 'application/json');
        headers = headers.set(this.headerLanguage, this.translate.currentLang);
        this.ignoreLoadingBar = false;

        encabezados.forEach(encabezado => {
            switch (encabezado) {
                case HeaderType.NoShowLoading:
                    headers = headers.set(this.headerNoSpinner, '');
                    this.ignoreLoadingBar = true;
                    break;
                case HeaderType.NoAuthenticate:
                    headers = headers.delete(this.headerAuthentication);
                    break;
                case HeaderType.Encryption:
                    headers = headers.set(environment.encryptionType, '');
                    //headers = headers.set('cipherMode', 'ECB');
                    break;
                default:
                    break;
            }
        });

        return headers;
    }

    encrypt(data: any) {

        switch (environment.encryptionType) {
            case 'AES-ENC':
                let security: Security = new Security();
                let encrypted = security.encryptAES(data, this.base64ToString(environment.aesKey));
                // let decrypted = security.decryptAES('eyJEYXRhIjoibjFzVW9kNmoxeEFVaXFTT2dRQWNxMUc1VjB6WXVIa2xyOC84NFQxMWl5V1pBazJhME5xcnFMRUJuRXZIWFVOQi9TMlVKYVlXemdvQWFHcGs1bUlGNm56dlVhK3lNU3NkV0ZkZTcxU3paTXNSUlhJcWx6TG5rR1g0VTczaXhjUnBmMnBhS08ySWoyZmtmaXdTcEJwSmJ2S2IyOGVJVmpFUXByd0tFbjRCa3JCVDAvdllYMjFuYU5VWWF6dkd1R2diT2FEUVVZczdHYnFWQWdIQjJpaXFxWDJTKy9qcTlsVWVZcHJjTzdEbDFrWXh1RnJZWk5FRkxGKzFDWjRSY29QQTlCNzNCdm8yRm5VU0hZOUZQK3drUnpvdXRlZHhLVGd0YXNqbC9HMk1DWlJpVjB6dTM4Y3krTTdhTGtJa2ZncmoySHBSZCt2ZURoYS9YNVBxMHE5M290T09MOHRZTTROSjJnQy9YVER1aGw0PSJ9', this.base64ToString(environment.aesKey));
                // console.log(decrypted);
                return encrypted;
            case 'RSA-ENC':
                return data;
            case 'JWT-ENC':
                return data;
            case 'JWE-ENC':
                return this.encryptData(data);
            default:
                return this.encryptData(data);
        }

    }

    //-- Encriptar los datos de LandingPage
    encryptData(datos: any) {
        let header =
        {
            alg: "HS256",
            typ: "JWT"
        }

        let stringifiedHeader = this.cryptoJS.enc.Utf8.parse(JSON.stringify(header));
        let encodedHeader = this.base64url(stringifiedHeader);

        let stringifiedData = this.cryptoJS.enc.Utf8.parse(JSON.stringify(datos));
        let encodedData = this.base64url(stringifiedData);

        let token = encodedHeader + "." + encodedData;

        let signature = this.cryptoJS.HmacSHA256(token, this.configService.config.secret);
        signature = this.base64url(signature);

        return token + "." + signature;
    }

    base64url(source: any) {
        let encodedSource = this.cryptoJS.enc.Base64.stringify(source);

        encodedSource = encodedSource.replace(/=+$/, '');

        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');

        return encodedSource;
    }

    base64ToString(cadena: any) {
        const words = this.cryptoJS.enc.Base64.parse(cadena);
        return this.cryptoJS.enc.Utf8.stringify(words);
    }

    base64ToBytes(base64String: string): Uint8Array
    {
        // Decodificar la cadena base64
        const binaryString = atob(base64String);

        // Crear un array con la longitud de la cadena decodificada
        const byteArray = new Uint8Array(binaryString.length);

        // Llenar el Uint8Array con los códigos de los caracteres de la cadena decodificada
        for (let i = 0; i < binaryString.length; i++)
        {
            byteArray[i] = binaryString.charCodeAt(i);
        }

        return byteArray;
    }

    decrypt(data: string, parseData: boolean = true): any {
        switch (environment.encryptionType) {
            case 'AES-ENC':
                let security: Security = new Security();
                let decrypted = security.decryptAES(data, this.base64ToString(environment.aesKey));
                return parseData ? JSON.parse(decrypted) : decrypted;
            case 'RSA-ENC':
                return data;
            case 'JWT-ENC':
                return data;
            case 'JWE-ENC':
                return this.decryptData(data);
            default:
                return this.decryptData(data);
        }
    }

    decryptData(response: string): string {
        let decode: string = jwt_decode(response);

        if (this.encryptData(decode) == response) {
            return decode;
        }
        else {
            return "";
        }
    }

    setDarkMode(value: boolean) {
        this.lightMode$.next(value);
    }

    getDarkModeSubscription() {
        return this.lightMode$.asObservable();
    }

    saveData<T>(data: T, uriApi: string, edit: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            if (edit) {
                this.put(uriApi, data).subscribe(
                    {
                        next: (response) => {
                            if (response.status === ResponseStatusType.OK) {
                                resolve(response);
                            }
                            else {
                                reject(new Error("ErrorDatos"));
                            }
                        },
                        error: (error) => {
                            reject(new Error('ErrorConexion'));
                        }
                    }
                );
            } else {
                this.post(uriApi, data).subscribe(
                    {
                        next: (response) => {
                            if (response.status == ResponseStatusType.CREATED) {
                                resolve(response);
                            }
                            else {
                                reject(new Error(response.message));
                            }
                        },
                        error: (error) => {
                            reject(new Error("ErrorConexion"));
                        }
                    }
                );
            }
        });
    }
}
